import React, { createContext, useMemo } from "react"
import { useMediaQuery } from "react-responsive"

interface DeviceContextType {
  isMobile: boolean
  isTablet: boolean
}

interface DeviceContextProviderProps {
  children: React.ReactNode
}

const DeviceContext = createContext<DeviceContextType | undefined>(undefined)

const DeviceProvider: React.FC<DeviceContextProviderProps> = ({ children }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" })
  const isTablet = useMediaQuery({ query: "(min-width: 768px) and (max-width: 1100px)" })

  const value = useMemo(() => ({
    isMobile,
    isTablet
  }), [isMobile, isTablet])

  return (
    <DeviceContext.Provider value={value}>
      {children}
    </DeviceContext.Provider>
  )
}


export { DeviceProvider, DeviceContext }